<template>
  <header class="app-header navbar" :style="{ backgroundColor: coloreSfondo, color: coloreTesto }">
    <b-link
      class="navbar-brand"
      href="https://www.cordivari.it/"
      target="blank"
      :style="'background-color:' + coloreSfondo + '; height: 60%;'"
    ></b-link>
    <div class="home-icon">
      <i class="fa-solid fa-house fa-2x" @click="goTo('dashboard')"></i>
    </div>
    <b-navbar-nav class="ml-auto">
      <LanguageHeaderDropdown></LanguageHeaderDropdown>
      <HeaderDropdown v-show="isAdmin || isDebug || isUnilab" />
    </b-navbar-nav>
    <span> &nbsp; &nbsp; &nbsp; </span>
  </header>
</template>
<script>
import HeaderDropdown from "./HeaderDropdown.vue";
import LanguageHeaderDropdown from "./HeaderLanguageDropdown.vue";
import store from "../../store";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Header",
  components: {
    HeaderDropdown,
    LanguageHeaderDropdown
  },

  data() {
    return {
      fullName: "",
      appsList: [],
      coloreSfondo: "",
      coloreTesto: ""
    };
  },

  computed: {
    ...mapGetters("_authModule", [
      "isUserLogged",
      "loggedUserInfo",
      "isAdmin",
      "isDebug",
      "isUnilab"
    ]),
    ...mapGetters("_prjModule", ["getProjectModality"]),
    ...mapGetters("_colorsModule", ["headerColors"]),
    //
    isAuthenticated() {
      var that = this;
      var ret = false;
      ret = that.isUserLogged;
      return ret;
    },
    projectModality() {
      var that = this;

      var modality = that.getProjectModality;
      var modStr = "";
      if (that.appsList.length > 0 && modality > 0) {
        modStr = that.appsList.find(el => el.id == modality).name;
      }

      var offerStr = "";

      var ret = modStr + (modStr && offerStr ? " - " : "") + offerStr;
      return ret;
    }
  },

  mounted: function() {
    var that = this;
    that.fullName = that.loggedUserInfo.fullName + "";

    that.setColors();

    that.getAppsAction().then(function(data) {
      data.forEach(app => {
        app.modalities.forEach(modality => {
          that.appsList.push({
            id: modality.id,
            name: app.name + ", " + that.uniTranslation(modality.name)
          });
        });
      });
    });
  },
  watch: {
    headerColors() {
      this.setColors();
    }
  },
  methods: {
    ...mapActions("_colorsModule", ["getColoriHeaderAction"]),
    ...mapActions("_dashboardModule", ["getAppsAction"]),
    setColors() {
      var that = this;
      that.coloreSfondo = that.headerColors[0]; // 2 elementi
      that.coloreTesto = that.headerColors[1];
    },
    goTo(comp) {
      this.$router.push("/" + comp).catch(() => {});
    },
    sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-hidden");
      store.dispatch("toggleSidebarProperty");
    },
    sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-minimized");
    },
    mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-mobile-show");
      store.dispatch("toggleSidebarProperty");
    },
    asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("aside-menu-hidden");
      store.dispatch("toggleAsideMenuProperty");
    }
  }
};
</script>
<style scoped>
.home-icon :hover {
  cursor: pointer;
}
</style>
